import { useState } from 'react';

import type { DateRange } from 'react-day-picker';

interface UseFilterDatePickerParams {
    value?: DateRange;
    onApply: (date?: DateRange) => void;
}

const completeSingleDayRange = (dateRange?: DateRange): DateRange | undefined => {
    if (!dateRange?.from || dateRange.to) {
        return dateRange;
    }

    return {
        from: dateRange.from,
        to: dateRange.from,
    };
};

const areDateRangesEqual = (first?: DateRange, second?: DateRange) =>
    first?.from?.getTime() === second?.from?.getTime() &&
    first?.to?.getTime() === second?.to?.getTime();

export const useFilterDatePicker = ({ value, onApply }: UseFilterDatePickerParams) => {
    const [isOpen, setIsOpen] = useState(false);
    const [draftDateRange, setDraftDateRange] = useState<DateRange | undefined>(value);

    const applyDateRange = () => {
        const completedDateRange = completeSingleDayRange(draftDateRange);

        setDraftDateRange(completedDateRange);

        if (!areDateRangesEqual(completedDateRange, value)) {
            onApply(completedDateRange);
        }
    };

    const applyDateRangeAndClose = () => {
        applyDateRange();
        setIsOpen(false);
    };

    const handleOpenChange = (open: boolean) => {
        if (open) {
            setDraftDateRange(value);
        } else {
            applyDateRange();
        }

        setIsOpen(open);
    };

    const clearDateRange = () => {
        setDraftDateRange(undefined);
        onApply();
    };

    return {
        applyDateRangeAndClose,
        clearDateRange,
        draftDateRange,
        handleOpenChange,
        isOpen,
        selectDateRange: setDraftDateRange,
    };
};
